import * as Yup from 'yup';

export const registrationSchema = Yup.object({
	email: Yup.string().email('emailInvalid').required('emailRequired'),
	password: Yup.string().min(8, 'passwordMinLength').required('confirmPasswordRequired'),
	// .matches(/[A-Z]/, 'Password must contain an uppercase letter')
	// .matches(/[a-z]/, 'Password must contain a lowercase letter'),
	repeatPassword: Yup.string()
		.oneOf([Yup.ref('password')], 'passwordsNotMatching')
		.required('confirmPasswordRequired'),
});

export const loginSchema = Yup.object({
	email: Yup.string().email('emailInvalid').required('loginError'),
	password: Yup.string().required('loginError'),
});

export const EmailSchema = Yup.object({
	email: Yup.string().email('emailInvalid').required('emailRequired'),
});

export const passwordSchema = Yup.object({
	password: Yup.string().min(8, 'passwordMinLength').required('passwordRequired'),
	repeatPassword: Yup.string()
		.oneOf([Yup.ref('password')], 'passwordsNotMatching')
		.required('confirmPasswordRequired'),
});

export const afterValidationRegistrationSchema = Yup.object({
	email: Yup.string().email('Invalid email address').required('Email is required'),
	password: Yup.string()
		.min(6, 'Password must be at least 6 characters')
		.required('Password is required'),
	repeatPassword: Yup.string()
		.oneOf([Yup.ref('password')], 'The passwords are not matching.')
		.required('Please confirm your password'),
	firstName: Yup.string()
		.required('First name is required')
		.min(3, 'First name must be at least 3 characters'),
	lastName: Yup.string()
		.required('Last name is required')
		.min(3, 'Last name must be at least 3 characters'),
	phone: Yup.string()
		.required('Phone number is required')
		.matches(/^\+?\d{10,15}$/, 'Phone number is not valid'),
	country: Yup.string().required('Country is required'),
	companyName: Yup.string().required('Company name is required'),
	companyId: Yup.string().required('Company ID is required'),
	crop: Yup.string().required('Crop is required'),
	representativeName: Yup.string().required('Representative name is required'),
	representativeLastName: Yup.string().required('Representative last name is required'),
	linkedinProfile: Yup.string()
		.notRequired() // Optional field
		.url('Invalid LinkedIn URL') // Validates the URL if provided
		.matches(/^https?:\/\/(www\.)?linkedin\.com\/.*$/, 'Invalid LinkedIn URL')
		.nullable(),
	termsAndConditions: Yup.boolean().oneOf([true], 'You must accept the terms and conditions'),
});
